import React from 'react';
import OrganizationAuthForm from "./OrganizationAuthForm";
import Modal from "../../../components/Modal";
import styled from "styled-components";

function DocOrgAuthPage() {
    return (<>
            <img src="./profdoctor.img.png" className={'auth__background'} alt="background"/>
            <Modal styles={{top: '0'}}>
                <Styled className="formModal">
                    <div onClick={()=>{window.location.href = 'https://profdoctor.net/'}} style={{position: 'absolute',width: '100%', height: '100%'}} />

                    <div className="auth__form">
                        <div className="auth__title">Вход</div>

                        <OrganizationAuthForm/>


                    </div>
                </Styled>
            </Modal>
        </>


    )
}

const Styled = styled.div`
  width: 100%;
  .auth__title {
    margin-bottom: 0;
  }
`

export default DocOrgAuthPage;
